import {
  CreateScope,
  DeleteScope,
  ReadScope,
  UpdateScope,
} from "../constants/AccessScopeConstants";

// Owner rule: Create, Update and Delete inherit Read. A role that can write
// to an area can always see it, so a Read check passes when the stored
// scope string for that area contains Read, Create, Update or Delete (for
// example a role saved before this rule existed). Create, Update and Delete
// checks stay exact: only their own literal word grants them.
const READ_IMPLIED_BY = [ReadScope, CreateScope, UpdateScope, DeleteScope];

export const checkRoleScope = (roleScope, scope, access) => {
  const areaScope = roleScope?.[scope];
  if (!areaScope) {
    return false;
  }
  if (access === ReadScope) {
    return READ_IMPLIED_BY.some((impliedAccess) =>
      areaScope.includes(impliedAccess)
    );
  }
  return areaScope.includes(access) || false;
};

// Route gating for a menu's child routes (used by Home.js's generateMenuRoutes).
// A child with a `permission` requirement keeps its own Component only when
// the role passes checkRoleScope for at least one of the areas guarding it
// (so Create, Update and Delete inherit Read here too); otherwise it comes
// back as a copy whose Component is fallbackComponent (typically
// ActionNotAllowed), so the route still exists and shows that page instead
// of a 404. A child with no `permission`, or no `Component` at all (a group
// entry), comes back unchanged.
//
// The given items are never changed: Home.js passes the module-level
// MenuConstants items, which outlive a sign out (no page reload). Writing
// the fallback into them took the real screen away from every role that
// signed in later on the same tab (code review phase 2, finding 4).
export const getAccessibleChildrens = (
  childrens,
  scopeAreas,
  roleScope,
  fallbackComponent
) =>
  childrens.map((item) => {
    if (!item.Component || !item.permission) {
      return item;
    }
    const isAllowed = (scopeAreas || []).some((area) =>
      checkRoleScope(roleScope, area, item.permission)
    );
    return isAllowed ? item : { ...item, Component: fallbackComponent };
  });
